export default "__VITE_ASSET__b5ed5f56__"